import { useCallback } from 'react';
import { useGetAuthToken } from './authTokenApi';
import { fetchAPI, RequestOptions } from './fetchAPI';

export const useFetchApi = () => {
  const { data: authToken } = useGetAuthToken();

  const fetch = useCallback(
    async <T>(url: string, options?: RequestOptions) => {
      return fetchAPI<T>(url, options, authToken ?? undefined);
    },
    [authToken]
  );

  return { fetch };
};
